import ImportModal from './ImportModal.container'

export default ImportModal
